// src/components/CreateCampaign.js

import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { GroupListhooks } from '../../Helper/GroupHelper';
import { Link } from 'react-router-dom';
import { CreateCampaignhooks,CampaignGetbyIdhooks } from '../../Helper/CampaginHelper';


const CreateCampaignComponent = (props) => {

    // State variables for form data and success/error messages
    const [CampaignData, setCampaignData] = useState({
        "campaignId": props.id,
        "name": '',
        "layoutGroupId": 0,
        "createdBy": localStorage.getItem("userId")
    });
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [resolutions, setResolutions] = useState([]);
    useEffect(() => {
        GetLayoutGroup();
        
        if (props.id !== undefined) {
            getData();
        }
    }, []);

    async function getData() {
        const data = await CampaignGetbyIdhooks(props.id);
        if (data !== undefined) {
            setCampaignData((prevData) => ({
                ...prevData,
                ...data,
                CampaignId: data.campaignId || '' // Ensure resolutionId is updated
            }));
        }
    }

    async function GetLayoutGroup() {
        try {
            const data = await GroupListhooks("", "Name", false, 1, 1000, 1);
            if (Array.isArray(data.items)) {
                setResolutions(data.items); // Ensure data is an array
            } else {
                console.error('Resolution data is not an array:', data);
                setResolutions([]); // Set to an empty array if data is not an array
            }
        } catch (err) {
            console.error('Error fetching resolutions:', err);
            setResolutions([]); // Handle error by setting resolutions to an empty array
        }
    }

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCampaignData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle resolution change
    const handleGroupChange = (e) => {
        const { value } = e.target;
        setCampaignData((prevData) => ({
            ...prevData,
            layoutGroupId: value, // Update resolutionId in Campaign data
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        
        e.preventDefault();
        setMessage('');
        setError('');
        var res = await CreateCampaignhooks(CampaignData);
        if (res !== undefined) {
            toast.success('Campaign created successfully!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            if (props.id === undefined) {
                setCampaignData({
                    name: '',
                    layoutGroupId: null
                });
            }

        } else {
            toast.error('Failed to create Campaign. Please try again!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    return (
        <div>

            <div class="container-fluid content-top-gap">

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">
                        {props.id !== undefined ? 'Edit Campaign' : 'Create Campaign'}
                    </h4>
                    
                    
                </div>
                <nav aria-label="breadcrumb" class="mb-4">
                    <ol class="breadcrumb my-breadcrumb">
                        <li class="breadcrumb-item"><a href="/">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {
                                props.id !== undefined ? 'Edit Campaign' : 'Create Campaign'
                            }
                        </li>
                        
                    </ol>
                </nav>

                <div class="accordions">
                    <div class="row">

                        <div class="col-lg-12 mb-4">
                            <div class="card card_border">
                                <div class="card-header chart-grid__header">
                                    {
                                        props.id !== undefined ? 'Edit Campaign' : 'Create Campaign'
                                    }


                                </div>
                                <div class="card-body">
                                    <div class="accordion" id="accordionExample">
                                        <div class="card">
                                            <div class="card-header " id="headingOne">

                                                {message && <p style={{ color: 'green' }}>{message}</p>}
                                                {error && <p style={{ color: 'red' }}>{error}</p>}
                                                <form onSubmit={handleSubmit}>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-sm-2'>
                                                                <label>Name:</label>
                                                            </div>
                                                            <div className='col-sm-10'>
                                                                <input
                                                                    type="text"
                                                                    id="name"
                                                                    className='form-control input-style'
                                                                    name="name"
                                                                    value={CampaignData.name}
                                                                    onChange={handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>


                                                    </div>

                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-sm-2'>
                                                                <label>Campaign Groups:</label>
                                                            </div>
                                                            <div className='col-sm-10'>
                                                                <select
                                                                    className='form-control input-style'
                                                                    name="resolutionId"
                                                                    value={CampaignData.layoutGroupId}
                                                                    onChange={handleGroupChange}
                                                                    required
                                                                >
                                                                    <option value="">Select Campaign Group</option>

                                                                    {resolutions.map(res => (
                                                                        <option key={res.id} value={res.groupId}>{res.groupName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <button type="submit" className='btn btn-success'>Save</button>
                                                </form>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



        </div>
    );
};

export default CreateCampaignComponent;
